import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ParameterTypeEnum } from 'src/app/enums/parameterType.enum';
import { ValueConversionService } from 'src/app/services/value-conversion.service';

@Component({
  standalone: false,
    selector: 'app-map-marker',
    templateUrl: './map-marker.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./map-marker.component.scss'],
})
export class MapMarkerComponent implements OnInit {

    private readonly WIND_DIRECTION_OFFSET = 135;

    @Input() id: number;
    @Input() endPointName: string;
    @Input() markerType: string;
    @Input() parameterColor: string;
    @Input() parameterValue: string;
    @Input() parameterType: ParameterTypeEnum;
    @Input() windSpeed: number;
    @Input() windDirection: number;
    parameterUnit: string;

    constructor(
        private valueConversionService: ValueConversionService
    ) { }

    ngOnInit(): void {
        if (this.parameterType != null) {
            const parameterNumber = Number(this.parameterValue);
            if (!isNaN(parameterNumber)) this.parameterValue = parameterNumber.toFixed(4);
            this.parameterUnit = this.valueConversionService.getParameterUnit(this.parameterType);
        }
    }

    get hasWindData(): boolean {
        return this.windSpeed != null && this.windDirection != null;
    }

    get windDirectionRotation(): string {
        if (this.windDirection == null) return 'rotate(0deg)';
        return `rotate(${this.windDirection + this.WIND_DIRECTION_OFFSET}deg)`;
    }

    get windSpeedDisplay(): string {
        if (this.windSpeed == null) return '';
        return this.windSpeed.toFixed(1);
    }

    get windSpeedUnit(): string {
        return this.valueConversionService.getParameterUnit(ParameterTypeEnum.WindSpeed);
    }
}
